export default __webpack_public_path__ + "static/media/document.888c3ca3.svg";